import {CKEditor} from "ckeditor4-react";

const config = {
  toolbar: [
    {name: "tools", items: ["Maximize"]},
    {
      name: "clipboard",
      items: ["Cut", "Copy", "Paste", "PasteText", "-", "Undo", "Redo"],
    },
    {name: "links", items: ["Link", "Unlink"]},
    {name: "document", items: ["Source"]},
    "/",
    {
      name: "basicstyles",
      items: [
        "Bold",
        "Italic",
        "Underline",
        "Strike",
        "-",
        "Subscript",
        "Superscript",
      ],
    },
    {
      name: "paragraph",
      items: [
        "NumberedList",
        "BulletedList",
        "-",
        "Outdent",
        "Indent",
        "Blockquote",
        "-",
        "JustifyLeft",
        "JustifyCenter",
        "JustifyRight",
        "JustifyBlock",
        "-",
      ],
    },

    "/",
    {
      name: "styles",
      items: ["Format", "-", "Font", "-", "FontSize"],
    },
    {name: "colors", items: ["TextColor", "BGColor"]},
    {name: "insert", items: ["Image", "Table", "HorizontalRule"]},
    "/",
  ],
  defaultContentLanguage: "fa",
  defaultLanguage: "fa",
  contentsLanguage: "fa",
  language: "fa",
  extraPlugins: "colorbutton,colordialog,font,justify",
  removeButtons: "",
};

export default function
    Toolbar(props) {
  const {inputData, setInputData, item} = props;

  const ckEditorChangeHandler = (e) => {
    if (props.HasManyInputData) {
      props.HasManyInputData(props.index, props.HasManyKey, e.editor.getData())
    } else {
      let object = inputData;
      let mapLocation = e.editor.getData();
      object[item.key] = mapLocation;
      setInputData(object);
    }
  };

  return (
      <div className="dark:bg-[#D1D4C9]">
        {Object.keys(inputData).length > 0 ? (
            <>
              <CKEditor
                  initData={`${inputData[item.key]}`}
                  // onInstanceReady={() => {
                  // }}
                  onChange={ckEditorChangeHandler}
                  type={"classic"}
                  config={config}
              />
            </>
        ) : (
            ""
        )}
      </div>
  );
}
